import script from "./ajudaView.vue?vue&type=script&setup=true&lang=js"
export * from "./ajudaView.vue?vue&type=script&setup=true&lang=js"

import "./ajudaView.vue?vue&type=style&index=0&id=746ac78e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-746ac78e"]])

export default __exports__